// import $ from 'jquery';

let lazyImages;
const doc = document.documentElement;
const lazyTolerance = 100;
let lastPosition = 0;
let checkingLazy = false;


export function loadLazily($img, src, type = 'image') {
  const status = $img[0].dataset.imageStatus;

  if (!status) {
    const fakeImage = document.createElement('img');
    fakeImage.onload = () => {
      if (type === 'image') {
        $img.attr('src', src);
        const srcScaled = $img.data('lazyImageScaled');
        if (srcScaled) { $img.attr('srcset', srcScaled); }

        $img[0].dataset.imageStatus = 'loaded';
      } else if (type === 'bg') {
        $img[0].style.backgroundImage = `url('${src}')`;
        $img[0].dataset.imageStatus = 'loaded';
      }
    };
    $img[0].dataset.imageStatus = 'loading';
    fakeImage.src = src;
  }
}

export function lazyLoadWath() {
  if (checkingLazy === true) {
    return true;
  }
  // let numberOfPictures = 0;
  function onRelod() {
    if ('requestAnimationFrame' in window) {
      window.requestAnimationFrame(onRelod);
    }
    const top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);

    // const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    lazyImages = Array.from(document.querySelectorAll('[data-lazy-image]:not([data-image-status]), [data-lazy-bg-image]:not([data-image-status])'));
    // lastPosition !== top ||
    if (lazyImages.length > 0 || checkingLazy === false) {
      checkingLazy = true;
      lastPosition = top;
      // numberOfPictures = lazyImages.length;
      lazyImages.map((item) => {
        const $img = $(item);
        const rect = item.getBoundingClientRect();
        if (rect.top > -lazyTolerance && rect.top < windowHeight + lazyTolerance && (rect.width + rect.height) > 0) {
          const src = $img.data('lazyImage');
          if ($img.attr('src') !== src && src) {
            loadLazily($img, src);
          } else if ($img.data('lazyBgImage')) {
            loadLazily($img, $img.data('lazyBgImage'), 'bg');
          }
        }
        return item;
      });
    }
  }
  onRelod();
  return lazyImages;
}


let responsiveImages;
export function updateMobileImage() {
  let lastSize = 0;
  let numberOfPictures = 0;
  function onRelod() {
    if ('requestAnimationFrame' in window) {
      window.requestAnimationFrame(onRelod);
    }

    const windowWidth = window.innerWidth;
    responsiveImages = Array.from(document.querySelectorAll('[data-mobile-image]'));
    if (numberOfPictures !== responsiveImages.length || lastSize !== windowWidth) {
      lastSize = 0;
      numberOfPictures = 0;
      responsiveImages.map((item) => {
        const $img = $(item);
        let src;
        let scaledURl = false;
        if (windowWidth < 734) {
          src = $img.data('mobileImage');
          scaledURl = $img.data('mobileImageScaled');
        } else {
          src = $img.data('defaultImage');
          scaledURl = $img.data('defaultImageScaled');
        }
        item.setAttribute('data-lazy-image', src);
        if (scaledURl) { item.setAttribute('data-lazy-image-scaled', scaledURl); }
        $img.data('lazyImageScaled');
        if ($img.attr('src') !== src) {
          if ($img.attr('src') && $img[0].dataset.imageStatus) {
            $img.attr('src', src);
            if (scaledURl) { $img.attr('srcset', scaledURl); }
          } else {
            lastPosition = null;
            lazyLoadWath();
          }
        }
        return item;
      });
    }
  }
  onRelod();

  if ('requestAnimationFrame' in window) {
    window.requestAnimationFrame(onRelod);
  } else {
    $(window).bind('resize', () => {
      onRelod();
    });
  }
}

$(document).ready(() => {
    lazyLoadWath();
    updateMobileImage();
})